import { FC, memo, useCallback } from 'react'
import { useForm } from 'react-final-form'
import { useIsMobile } from 'hooks/media'

import ModalFormDesktop from './Desktop'
import ModalFormMobile from './Mobile'
import { ModalFormProps } from './types'

const ModalForm: FC<ModalFormProps> = (props) => {
  const { isDialogType, onClose, confirmMessage, mobileConfirmation, ...otherProps } = props
  const isMobile = useIsMobile()
  const form = useForm()
  const { dirty } = form.getState()
  const handleCloseWithConfirm = useCallback(() => {
    if (dirty) {
      if (
        typeof onClose === 'function' &&
        // eslint-disable-next-line no-alert
        confirm(
          confirmMessage ||
            'Вы ввели новую информацию на этой странице. Если вы покинете страницу, предварительно не сохранив изменения, они будут потеряны.'
        )
      ) {
        onClose()
      }

      return
    }
    onClose && onClose()
  }, [confirmMessage, dirty, onClose])

  return isMobile ? (
    <ModalFormMobile
      {...otherProps}
      confirmation={mobileConfirmation}
      handleCloseWithConfirm={handleCloseWithConfirm}
      isDialogType={isDialogType ? !isMobile : false}
    />
  ) : (
    <ModalFormDesktop
      {...otherProps}
      handleCloseWithConfirm={handleCloseWithConfirm}
      isDialogType={isDialogType ? !isMobile : false}
    />
  )
}

export default memo(ModalForm)
